<template>
  <div class="expenseList">
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @companyChange="companyChange"
      @projectChange="projectChange"
      @periodChange="periodChange"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :showFooter="true"
        :footer-method="footerMethod"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :min-width="120"
          :sortable="item.sortable"
          :field="item.field"
          :formatter="item.formatter"
          :params="item.params"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <sirui-upload :action="action" ref="SiruiUpload" :data="token"></sirui-upload>
  </div>
</template>
<script>
  import API from '@/api/productCenter/expenseDetail';
  import siruiUpload from '@/components/SiruiUpload';
  import tableMixins from '@/common/mixins/table.js';
  import DataBaseAPI from '@/api/dataBase';
  export default {
    name: 'expenseList',
    components: {
      siruiUpload,
    },
    mixins: [tableMixins],
    computed: {
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          {
            // 公司
            prop: 'businessCompanyCode',
            name: this.$t('expenseDetail.column.businessCompanyName'),
            type: 'select',
            options: this.companyList,
            changeMethod: 'companyChange',
            filterable: true,
          },
          {
            // 业务部门
            prop: 'businessDepartmentCode',
            name: this.$t('expenseDetail.column.businessDepartmentName'),
            type: 'select',
            options: this.departmentList,
            filterable: true,
          },
          {
            // 操作人
            prop: 'createBy',
            name: this.$t('expenseDetail.column.createBy'),
            type: 'searchTableSpec',
            searchType: 'personnel',
            isMultiple: true,
          },
          {
            // 创建日期从
            prop: 'gmtCreateStart',
            name: this.$t('expenseDetail.column.gmtCreateStart'),
            type: 'startDaterangePicker',
          },
          {
            // 创建日期到
            prop: 'gmtCreateEnd',
            name: this.$t('expenseDetail.column.gmtCreateEnd'),
            type: 'endDaterangePicker',
          },
          {
            // 项目名称
            prop: 'projectCode',
            name: this.$t('expenseDetail.column.projectName'),
            type: 'dict',
            dictType: 'produce_product_proname',
            changeMethod: 'projectChange',
          },
          {
            // 费用主体
            prop: 'expenseEntity',
            name: this.$t('expenseDetail.column.expenseEntity'),
            type: 'input',
          },
          {
            // 费用类别
            prop: 'expenseType',
            name: this.$t('expenseDetail.column.expenseType'),
            type: 'dict',
            dictType: 'pdExpenseType',
          },
          {
            // 费用名称
            prop: 'expenseName',
            name: this.$t('expenseDetail.column.expenseName'),
            type: 'input',
          },
          {
            // 不含税金额(元)
            prop: ['amountWithoutTaxCondition', 'amountWithoutTax'],
            name: this.$t('expenseDetail.column.amountWithoutTax'),
            type: 'selectInput',
            options: [
              { value: 1, label: '等于' },
              { value: 2, label: '不等于' },
              { value: 3, label: '大于' },
              { value: 4, label: '小于' },
            ],
          },
          {
            // 含税金额(元)
            prop: ['amountWithTaxCondition', 'amountWithTax'],
            name: this.$t('expenseDetail.column.amountWithTax'),
            type: 'selectInput',
            options: [
              { value: 1, label: '等于' },
              { value: 2, label: '不等于' },
              { value: 3, label: '大于' },
              { value: 4, label: '小于' },
            ],
          },
          {
            // 费用明细编码
            prop: 'docNo',
            name: this.$t('expenseDetail.column.docNo'),
            type: 'input',
          },
          {
            // 结算周期
            prop: 'periodName',
            name: this.$t('expenseDetail.column.periodName'),
            type: 'searchTableSpec',
            searchType: 'pdPeriod',
            isMultiple: true,
            extraData: {
              projectCode: this.query.projectCode,
            },
            currentValue: this.query.periodName,
            changeMethod: 'periodChange',
          },
        ];
      },
    },
    data() {
      return {
        action: API.IMPORT_PDEXPENSEDETAIL,
        exportAction: API.EXPORT_PDEXPENSEDETAIL,
        query: {
          businessCompanyCode: null,
          businessDepartmentCode: null,
          createBy: null,
          gmtCreateStart: null,
          gmtCreateEnd: null,
          projectCode: null,
          expenseEntity: null,
          expenseType: null,
          expenseName: null,
          amountWithoutTaxCondition: null,
          amountWithoutTax: null,
          amountWithTaxCondition: null,
          amountWithTax: null,
          docNo: null,
          periodCode: null,
          periodName: null,
        },
        columnListDefault: [
          { type: 'checkbox', width: '50', fixed: 'left' }, // 复选框
          { field: 'projectName', title: 'expenseDetail.column.projectName' }, // 项目名称
          { field: 'periodName', title: 'expenseDetail.column.periodName' }, // 结算周期
          { field: 'expenseEntity', title: 'expenseDetail.column.expenseEntity' }, // 费用主体
          {
            field: 'expenseType',
            title: 'expenseDetail.column.expenseType',
            dictType: 'pdExpenseType',
          }, // 费用类别
          {
            field: 'expenseName',
            title: 'expenseDetail.column.expenseName',
            dictType: 'pdExpenseName',
          }, // 费用名称
          { field: 'docNo', title: 'expenseDetail.column.docNo' }, // 费用明细编码
          {
            field: 'amountWithTax',
            title: 'expenseDetail.column.amountWithTax',
            format: 'formatAmount',
          }, // 含税金额(元)
          { field: 'taxRate', title: 'expenseDetail.column.taxRate' }, // 税率
          {
            field: 'amountWithoutTax',
            title: 'expenseDetail.column.amountWithoutTax',
            format: 'formatAmount',
          }, // 不含税金额(元)
          { field: 'businessCompanyName', title: 'expenseDetail.column.businessCompanyName' }, // 公司
          { field: 'businessDepartmentName', title: 'expenseDetail.column.businessDepartmentName' }, // 业务部门
          { field: 'businessUser', title: 'expenseDetail.column.businessUser' }, // 业务员
        ],
        companyList: [],
        departmentList: [],
      };
    },
    mounted() {
      this.getData();
      this.getCompany();
      this.getButtonList();
      this.getCurrentDepartment();
    },
    methods: {
      async getData() {
        // 获取列表数据
        this.load = true;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = { ...this.query, pageNum, pageSize };
        params.createBy = params.createBy ? params.createBy[0].id : null;
        let res = await this.$axios.post(API.QUERY_PDEXPENSEDETAIL_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (['amountWithTax', 'amountWithoutTax'].includes(column.property)) {
              let subtrahend = 0;
              for (let i = 0; i < data.length; i++) {
                subtrahend = this.$cal.calCommon(data[i][column.property], subtrahend, '+');
              }
              return this.$baseRequest.formatTableColumn(subtrahend);
            }
            return null;
          }),
        ];
      },
      // 获取当前登录用户所在的公司部门
      async getCurrentDepartment() {
        let personDepartmentInfo = [];
        const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
        };

        await this.$axios.post(DataBaseAPI.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            personDepartmentInfo = res.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });

            this.query.businessDepartmentCode = personDepartmentInfo[0].value;
            this.departmentList = personDepartmentInfo;
          }
        });
        //this.getData();
      },
      async getCompany() {
        // 公司
        let params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo.map((item) => {
            return {
              value: item.personCompanyCode,
              label: item.personCompanyName,
            };
          });
        }
      },
      async getDepartment(companyCode) {
        // 取一级部门的最后一级部门
        if (companyCode) {
          let params = {
            id: this.userInfo.userInfo.userCode,
            userCode: this.userInfo.userInfo.userCode,
            personName: this.userInfo.userInfo.userName,
            personCompanyCode: companyCode,
          };
          const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
          if (selectStatus.data.code == 0) {
            this.departmentList = selectStatus.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
          }
        } else {
          this.departmentList = [];
        }
      },
      companyChange(val) {
        // 切换公司
        this.query.businessDepartmentCode = null;
        this.getDepartment(val.val);
      },
      projectChange() {
        // 切换项目
        this.query.periodCode = this.query.periodName = null;
      },
      periodChange(val) {
        // 切换期间
        let res = val.val;
        if (res && res.length > 0) {
          this.query.periodCode = res[0].periodCode;
          this.query.periodName = res[0].periodName;
        } else {
          this.query.periodCode = this.query.periodName = null;
        }
        if (res[0].periodStatus == 'closed') {
          //关闭的账期不能对数据进行增删改
          this.menuButtonList.forEach((item) => {
            if (['del'].indexOf(item.attributes.buttonUrl) > -1) {
              item.isDisabled = true;
            } else {
              item.isDisabled = false;
            }
          });
        } else {
          this.menuButtonList.forEach((item) => {
            item.isDisabled = false;
          });
        }
      },
      chooseClick(type) {
        if (type == 'add') {
          // 新增
          this.toPath('expenseAdd', {});
        } else if (type == 'edit') {
          // 修改
          if (this.multipleSelection.length != 1) {
            return this.tips('xTable.selectOne', 'error');
          }
          this.toPath('expenseEdit', { id: this.multipleSelection[0].id });
        } else if (type == 'del') {
          // 删除
          this.handleDel();
        } else if (type == 'export') {
          // 导出
          this.commonExport();
        } else if (type == 'import') {
          // 导入
          this.handleImport();
        }
      },
      handleDel() {
        // 删除
        if (this.multipleSelection.length == 0) {
          return this.tips('message.noData', 'error');
        }
        let delIds = this.multipleSelection.map((i) => {
          return i.id;
        });
        this.$confirmAction(this.$t('confirm.delete'))
          .then(() => {
            this.$axios.post(API.SAVE_PDEXPENSEDETAIL, { delIds }).then((res) => {
              if (0 == res.data.code) {
                this.$message({ showClose: true, message: res.data.msg, type: 'success' });
                this.resetBtnClick();
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.tips('confirm.deleteCancelled', 'info');
          });
      },
      dblclickEvent(value) {
        // 列表双击
        this.toPath('expenseDetail', { id: value.row.id });
      },
      handleImport() {
        // 导入
        this.$refs.SiruiUpload.openDialog(true);
      },
      tips(info, type) {
        // 提示
        this.$message({ showClose: true, message: this.$t(info), type: type });
      },
      toPath(name, query) {
        // 跳转路径
        let path = {
          path: `/production/${name}`,
          name: name,
          meta: {
            keepAlive: true,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
